<template>
    <div class="poster-template">
        <pt-img class="banner-picture" :src="detail.imageUrl ? detail.imageUrl : 'https://lb-sit-public.oss-cn-beijing.aliyuncs.com/goods/5c9b2e1c2defd600015f7e43/3802e394-23a9-482a-a6d7-8cf4521251bf.jpg'"></pt-img>

        <div class="footer" :style="{background:detail.themeColor}">
            <div class="description" >
                <img src="~images/avatar.png" alt="">
                <!-- <p v-html="description"></p> -->
            </div>
            <span class="qrcode"></span>
            <p v-html="detail.rightText"></p>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    detail (val) {
      console.log('---val', val)
    }
  },
  data () {
    return {
      description: `我是天津市脐血库的第<span style='color:${this.detail.themeColor}'>1130</span>位储户<br/>已为宝宝存储<span style='color:${this.detail.themeColor}'>11</span>年新生儿干细胞<br/>这是生命赐予的一份弥足珍贵的宝藏<br/>在这里，为宝宝种下一颗健康成长的种子`
    }
  },
  components: {

  }
}
</script>

<style lang="less">
.poster-template{
    padding:20px 20px 0;
    display: flex;
    flex-direction: column;
    .banner-picture{
        width: 100%;
        border-radius: 0;
    }
    .footer{
        padding:10px 20px;
        color:#000;
        position: relative;
        display: flex;
        align-items: center;
        .qrcode{
            width:50px;
            height: 50px;
            background: #dfdfdf;
            margin-right: 10px;
        }
        .description{
            position: absolute;
            bottom:100%;
            left: 50%;
            width: 90%;
            padding:30px 10px;
            // background: rgba(255, 255, 255, .8);
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;
            transform: translate(-50%,0);
            display: flex;
            img{
                width:50px;
                height: 50px;
                border-radius: 50%;
                border:2px solid #fff;
                margin-right: 5px;
            }
            p{
                margin:0
            }
        }
    }
}

</style>
